import styled from 'styled-components';

export const Container = styled.nav`
  width: 100%;
  height: 36px;
  background: #003e7b;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
`;

export const Content = styled.div`
  width: 100%;
  height: 36px;
  max-width: 1140px;
  margin: 0 40px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  position: relative;
`;

export const NavMenu = styled.div`
  width: 240px;
  color: #ffffff;
  background-color: #d58500;
  cursor: pointer;
  position: relative;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  button {
    height: 36px;
    padding: 8px 24px;
    color: #ffffff;
    background: transparent;
    border: none;
    outline: none;
    text-align: left;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  > button:hover {
    font-weight: bold;
  }
`;

export const NavMenuOptions = styled.div`
  width: ${({ width }) => (width ? `${width}px` : '240px')};
  background-color: #d58500;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  flex-direction: column;
  border-top-right-radius: ${({ width, maxMD }) =>
    width && !maxMD ? '8px' : '0'};
  border-top-left-radius: ${({ maxMD }) => (!maxMD ? '0' : '8px')};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  position: absolute;
  top: 36px;
  left: ${({ maxMD }) => maxMD && '-272px'};

  a {
    display: inline-block;
    height: 36px;
    padding: 8px 24px;
    color: #ffffff;
    text-decoration: none;
    position: relative;

    &:first-child {
      border-top-right-radius: ${({ width }) => (width ? '8px' : '0')};
    }

    &:last-child {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }

    &:hover {
      font-weight: bold;
    }

    &:not(:first-child):before {
      display: block;
      content: '';
      width: ${({ width }) => (width ? `${width - 40}px` : '200px')};
      height: 2px;
      background-color: #333;
      opacity: 20%;

      position: absolute;
      top: -1px;
      left: 20px;
    }
  }

  p {
    display: inline-block;
    height: 36px;
    padding: 8px 24px;
    color: #ffffff;
    cursor: default;
    position: relative;

    &:before {
      display: block;
      content: '';
      width: ${({ width }) => (width ? `${width - 40}px` : '200px')};
      height: 2px;
      background-color: #333;
      opacity: 20%;

      position: absolute;
      top: -1px;
      left: 20px;
    }
  }
`;

export const NavItemWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const NavItem = styled.div`
  position: relative;

  & + div {
    margin-left: 16px;
  }

  button {
    height: 36px;
    padding: 0 16px;
    color: #ffffff;
    background: ${({ selected }) => (selected ? '#d58500' : 'transparent')};
    border: none;
    outline: none;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: ${({ selected }) => (selected ? '0' : '8px')};
    border-bottom-right-radius: ${({ selected }) => (selected ? '0' : '8px')};

    &:hover {
      background-color: #d58500;
    }
  }
`;

export const SearchButton = styled.button`
  height: 36px;
  padding: 0 4px;
  color: #d58500;
  background: transparent;
  border: none;
  outline: none;
  margin-left: 16px;
  margin-right: -4px;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #ffffff;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;
